import { Logger, LoggerService } from '@Shared/logger';
import { HttpService } from '@Shared/http/http.service';
import type { DatafileContent } from '@featurevisor/sdk';

export class FeaturesRepository {
  private Logger: Logger = LoggerService.createLogger('FeaturesRepository');

  private static instance: FeaturesRepository;
  static get Instance(): FeaturesRepository {
    if (this.instance === null || this.instance === undefined) {
      this.instance = new FeaturesRepository();
    }
    return this.instance;
  }

  constructor() {
    this.Logger.trace('**** CTOR ****');
  }

  /**
   * Fetches the Featurevisor datafile.
   * @param url absolute URL of the datafile
   * @param cacheDuration cache duration in seconds
   * @param bypassCache drop any cached copy first so the latest revision is fetched (and re-cached)
   */
  public async fetchDatafile(
    url: string,
    cacheDuration: number,
    bypassCache: boolean = false,
  ): Promise<DatafileContent> {
    this.Logger.trace('fetchDatafile', url, { bypassCache });
    const httpService = new HttpService('', cacheDuration);
    if (bypassCache) {
      httpService.clearCache(url);
    }
    return await httpService.get<DatafileContent>(url);
  }
}
